import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/240723/M_ECB-{nnn}.png',
}

export default {
  supports360: false,
  layers: [body],
  resolveOptions: () => ({}),
}
